import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductTypeForm from '../../../../components/masters/styles/productType/ProductTypeForm';
import ProductTypeTable from '../../../../components/masters/styles/productType/ProductTypeTable';
import { addProductTypeAction, updateProductTypeAction, clearProductTypeEdit } from '../../../../redux/actions/masters/styles/productType/productTypeAction';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';
import { fetchCompanies } from '../../../../redux/actions/masters/company/companyAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .product-type-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .product-type-form, .product-type-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const ProductTypePage = () => {
  const dispatch = useDispatch();
  const { editingProductType } = useSelector((state) => state.productType);
  const users = useSelector(state => state.users.list || []);
  const companies = useSelector(state => state.company.list || []);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchCompanies());
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccess('');
    setFormError('');
  };

  const handleSubmit = async (form) => {
    try {
      if (editingProductType && editingProductType.product_type_id) {
        await dispatch(updateProductTypeAction({ id: editingProductType.product_type_id, productType: form }));
        setFormError('');
      } else {
        await dispatch(addProductTypeAction(form));
        setFormError('');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message;
      if (
        err?.response?.status === 409 ||
        (message && message.toLowerCase().includes('already exists'))
      ) {
        setFormError('');
        throw err;
      }
      setFormError(message || 'An error occurred.');
      throw err;
    }
  };

  const handleCancel = () => {
    dispatch(clearProductTypeEdit());
    setFormSuccess('');
    setFormError('');
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="product-type-flex">
        <div style={tableContainer} className="product-type-table">
          <ProductTypeTable onNew={handleFormReset} />
        </div>
        <div style={formContainer} className="product-type-form">
          <ProductTypeForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingProductType={editingProductType}
            onCancel={handleCancel}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            users={users}
            companies={companies}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductTypePage; 